import { Box, Grid } from "@mui/material";
import React, { useMemo } from "react";
import { RenderInputsRowByType } from "../../../../components/formGroupGenerator/RenderInputRowByType";
import { CustomSection } from "../CustomSection";
import { InfoBox } from "../InfoBox";
import { IndicadorEstado } from "../../../ContratosCreation/components/IndicadorEstado/IndicadorEstado";
import { CustomChip } from "../../../../components/chip/Chip";

const ESTADO_CONTRATO = {
  inactivo: 'Inactivo',
  servicio: 'En Servicio',
  suspendido: 'Suspendido',
}

export function EnvioSection({ formValues, handleChange, inputs, bloqueoClienteSAP, announcement }) {
  const { delegacion, paciente, edad, hC, codSAPPaciente, cobertura, motivoSuspension, estadoAsistencial } =
    formValues || {};

  const estadoAsistencialMemo = useMemo(() => {
    if (!estadoAsistencial) {
      return <CustomChip label={'-'} isLightGray title={'-'} />;
    }

    switch (estadoAsistencial) {
      case ESTADO_CONTRATO.servicio:
        return <CustomChip label={estadoAsistencial} isGreen title={estadoAsistencial} />;
      case ESTADO_CONTRATO.suspendido:
        return <CustomChip label={estadoAsistencial} isRed title={estadoAsistencial} />;
      case ESTADO_CONTRATO.inactivo:
        return <CustomChip label={estadoAsistencial} isYellow title={estadoAsistencial} />;
      default:
        return <CustomChip label={estadoAsistencial || '-'} isLightGray title={estadoAsistencial || '-'} />;
    }
  }, [estadoAsistencial]);

  const codCoberturaValue = (
    <Box sx={{ display: "flex", alignItems: "flex-start"}}>
      <Box>{cobertura || "-"}</Box>
      <Box sx={{ ml: 2 }}>
        <IndicadorEstado type={!bloqueoClienteSAP ? 'success' : 'error'} />
      </Box>
    </Box>
  );

  return (
    <CustomSection title="Envío" announcement={announcement}>
      <Box
        sx={{
          display: "grid",
          gap: "15px",
          marginBottom: '15px',
          gridTemplateColumns: { lg: `repeat(${motivoSuspension ? 24 : 20}, 1fr)`, md: "repeat(2, 1fr)" },
        }}
      >
        <InfoBox
          label="Delegación"
          value={delegacion || "-"}
          gridColumn={{ lg: 'span 3', md: 'span 1' }}
        />
        <InfoBox
          label="Paciente"
          value={paciente || "-"}
          gridColumn={{ lg: 'span 3', md: 'span 1' }}
        />
        <InfoBox
          label="Edad"
          value={edad}
          gridColumn={{ lg: 'span 1', md: 'span 1' }}
        />
        <InfoBox
          label="HC"
          value={hC || "-"}
          gridColumn={{ lg: 'span 1', md: 'span 1' }}
        />
        <InfoBox
          label="Cod. SAP"
          value={codSAPPaciente || "-"}
          gridColumn={{ lg: 'span 1', md: 'span 1' }}
        />
        <InfoBox
          label="Cod. Cobertura"
          value={codCoberturaValue}
          gridColumn={{ lg: 'span 7', md: 'span 1' }}
        />
        <InfoBox
          label="Estado Asistencial"
          value={estadoAsistencialMemo}
          gridColumn={{ lg: 'span 4', md: 'span 1' }}
        />
        {motivoSuspension && <InfoBox
          label="Motivo Suspensión"
          value={<CustomChip label={motivoSuspension} isRed title={motivoSuspension} />}
          gridColumn={{ lg: 'span 4', md: 'span 1' }}
        />}
      </Box>
      <Grid container columnSpacing={3} rowSpacing={3} columns={100}>
        {inputs.map((input, index) => {
          return (
            <RenderInputsRowByType
              key={`name-${input.name}-index${index}`}
              input={input}
              value={formValues[input.name]}
              handleChange={handleChange}
            />
          );
        })}
      </Grid>
    </CustomSection>
  );
}
